import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const ResourcesOutlineIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="ResourcesOutlineIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/resources/outline">
            <g id="Vector">
                <path
                    d="M8.3 9.99981C8.17109 10.0068 8.04274 9.97809 7.92916 9.91673C7.81557 9.85537 7.72116 9.76379 7.65637 9.65212C7.59159 9.54046 7.55894 9.41304 7.56205 9.28398C7.56517 9.15492 7.60391 9.02922 7.674 8.92081L11.4 2.99981C11.4585 2.89437 11.5433 2.80586 11.6462 2.74284C11.749 2.67981 11.8663 2.64442 11.9869 2.6401C12.1074 2.63577 12.227 2.66266 12.334 2.71815C12.4411 2.77363 12.532 2.85584 12.598 2.95681L16.3 8.89981C16.373 9.0046 16.4159 9.12735 16.4241 9.25478C16.4323 9.38221 16.4055 9.50946 16.3466 9.62276C16.2877 9.73605 16.1989 9.83107 16.0899 9.89753C15.9808 9.96399 15.8557 9.99936 15.728 9.99981H8.3Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                </path>
                <path
                    d="M9 13.9998H4C3.44772 13.9998 3 14.4475 3 14.9998V19.9998C3 20.5521 3.44772 20.9998 4 20.9998H9C9.55228 20.9998 10 20.5521 10 19.9998V14.9998C10 14.4475 9.55228 13.9998 9 13.9998Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                </path>
                <path
                    d="M17.5 20.9998C19.433 20.9998 21 19.4328 21 17.4998C21 15.5668 19.433 13.9998 17.5 13.9998C15.567 13.9998 14 15.5668 14 17.4998C14 19.4328 15.567 20.9998 17.5 20.9998Z"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                </path>
            </g>
        </g>
    </SvgIcon>
)
